import * as angular from "angular";
import entityModalTabComponents from "./components";
import entityAliasesTab from "./entity-aliases-tab";
import entityBusinessesTab from "./entity-businesses-tab";
import entityContactsTab from "./entity-contacts-tab";
import entityCustomerTab from "./entity-customer-tab";
import entityEffectiveRangesTab from "./entity-effective-ranges-tab";
import entityGeometriesTab from "./entity-geometries-tab";
import entityInventoryTab from "./entity-inventory-tab";
import entityOverviewTab from "./entity-overview-tab";
import entityProductsTab from "./entity-products-tab";
import entityReportingTab from "./entity-reporting-tab";
import entitySchemaTabs from "./entity-schema-tabs";
import entityTokensTab from "./entity-tokens-tab";
import entityUsersTab from "./entity-users-tab";

export default angular
	.module("vesl.components.entity-modal.tabs", [
		entityModalTabComponents,
		entityAliasesTab,
		entityBusinessesTab,
		entityContactsTab,
		entityCustomerTab,
		entityEffectiveRangesTab,
		entityGeometriesTab,
		entityInventoryTab,
		entityOverviewTab,
		entityProductsTab,
		entityReportingTab,
		entitySchemaTabs,
		entityTokensTab,
		entityUsersTab
	])
	.name;
